

<template>
  <div class="ratio">
    <div class="ratioEvery">
      <div class="divE">
        <div class="Tit">{{tit1}}</div>
        <div class="Tit">{{tit2}}</div>
      </div>
      <div class="divE">
        <i class="el-icon-caret-right"></i>
      </div>
      <div class="divE">
        <div class="dayYes">昨日</div>
        <div class="dayYes">{{rate.yesterday_rate}}</div>
      </div>
      <div class="divE ">
        <div class="beforYes">前日</div>
        <div class="beforYes">{{rate.before_yesterday_rate}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rate: {
      type: Object
    },
    tit1: {
      type: String,
      default: ""
    },
    tit2: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.ratio {
    width: 100%;
    height: 100%;
}
.ratio .ratioEvery {
  /*height: 260px;*/
  height: 200px;
  display: flex;
  flex: 1;
  /*justify-content: space-between;*/
  justify-content: space-evenly;
  flex-direction: column;
}
.divE {
  text-align: center;
}
.Tit {
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  color: #7f7f7f;
  text-align: center;
}
.el-icon-caret-right {
  font-size: 33px;
  color: #e1f6fc;
//   margin: 44px 0;
}

.dayYes {
  font-weight: 400;
  font-size: 12px;
  color: #7f7f7f;
  text-align: center;
  line-height: 13px;
}
.beforYes {
  font-weight: 400;
  font-size: 12px;
  color: #7f7f7f;
  text-align: center;
  line-height: 13px;
}
</style>
